import * as React from 'react';
import '../../styles/styles.scss';

export interface IntermixModalProps {
  onCloseHandler: () => any;
}

export const IntermixModal: React.FC<IntermixModalProps> = ({
  onCloseHandler,
  children,
}) => {
  const [open, setOpen] = React.useState(true);
  const showHideClassName = open ? 'modal display-block' : 'modal display-none';

  const closeModal = () => {
    setOpen(false);
    onCloseHandler();
  };
  return (
    <div className={showHideClassName}>
      <div className="modal-main animated zoomInUp">
        <div onClick={closeModal} className="modal-main__close">
          x
        </div>
        {children}
      </div>
    </div>
  );
};
